<template>
  <div class="header">
    <router-link :to="{ name: 'Exams' }">
      <img src="@/assets/header/logo_eng.svg" alt="">
    </router-link>
    <nav class="navigation">
      <ul :class="{ hidden: !loggedIn }">
        <li>
          <router-link :to="{ name: 'Exams' }">
            <span class="list-icon"></span>
            {{ $t('header.MY_EXAMS') }}
          </router-link>
        </li>
        <li v-if="isStaff">
          <router-link :to="{ name: 'NewExaminer' }">
            <span class="add-icon"></span>
            {{ $t('header.NEW_EXAMINER') }}
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'NewExam' }">
            <span class="add-icon"></span>
            {{ $t('header.NEW_EXAM') }}
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'NewStudents' }">
            <span class="new-students-icon"></span>
            {{ $t('header.NEW_STUDENTS') }}
          </router-link>
        </li>
      </ul>
    </nav>
    <div class="user-menu">
      <div v-if="loggedIn">
        <router-link class="user-menu-link" :to="{ name: 'Profile' }" >
          <span class="settings-icon"></span>
        </router-link>
        <span>{{ fullName(user) }}</span>
        <a class="user-menu-link" @click.prevent="logout">
          <span class="logout-icon"></span>
        </a>
      </div>
      <div v-else>
        <router-link class="primary-button" :to="{ name: 'Login' } ">
          {{ $t('header.LOGIN') }}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { fullName } from '@/utils/utils.format'

export default {
  name: 'Header',
  methods: {
    logout () {
      this.$store.dispatch('logout')
        .then(() => this.$router.push({ name: 'Login' }))
    },
    fullName
  },
  computed: {
    ...mapState([
      'user'
    ]),
    ...mapGetters([
      'loggedIn',
      'isStaff'
    ])
  }
}
</script>

<style lang="scss" scoped>
@import "~@/styles/base.scss";

$active-link-opacity: 0.7;
$menu-link-font-size: 18px;
$navlink-active-border: $main-high 0.15em solid;
$navlink-hover-border: $accent 0.15em solid;

.header {
  display: flex;
  align-items: center;
  background-color: $paper-bg;
  padding: 0 40px;
  height: 4.5rem;

  border-bottom: 1px solid #C4C4C4;
}

.navigation {

  height: 100%;

  ul {
    list-style: none;
    display: flex;
    align-items: center;
    height: inherit;
    margin: 0;
    padding: 0 10px;
  }

  li {
    padding: 0 10px;
  }

  .router-link-exact-active {
    border-top: $navlink-active-border;
    opacity: $active-link-opacity;
  }

  a {
    display: flex;
    cursor: pointer;
    font-size: $menu-link-font-size;
    border-top: $paper-bg 0.15em solid;
    padding: 0.6em 0;
    transition: border-top-color 0.20s;

    &:hover:not(.router-link-exact-active) {
      border-top: $navlink-hover-border;
    }
  }
}

.user-menu {
  margin-left: auto;

  & > div {
    display: flex;
    align-items: center;
  }

  .user-menu-link {
    display: flex;
    cursor: pointer;
    align-items: center;
    transition: opacity .3s ease;

    &:hover {
      opacity: $active-link-opacity;
    }
  }
}

.list-icon {
  @extend %nav-icon;
  background-image: url("~@/assets/header/list.svg");
}

.add-icon {
  @extend %nav-icon;
  background-image: url("~@/assets/header/plus-circle.svg");
}

.new-students-icon {
  @extend %nav-icon;
  background-image: url("~@/assets/header/user-plus.svg");
}

.settings-icon {
  @extend %nav-icon;
  background-image: url("~@/assets/header/settings.svg")
}

.logout-icon {
  @extend %nav-icon;
  margin-left: 7px;
  background-image: url("~@/assets/header/log-out.svg");
}
</style>
